import React from 'react';
import PropTypes from 'prop-types';
import SchoolDetails from '../SchoolDetails';
import WebLinks from '../../containers/WebLinks';

import './styles.css';

export default function Masthead({
  hubsWebLinks,
  schoolName,
  collapsed = false,
  userData,
  collegeContact,
  admissionsOffice,
  sendEmail,
  handleCollegeUrlClick,
  virtualTour,
  headerMessage,
  ...rest
}) {
  return (
    <div
      className={`common-core-width masthead-container ${collapsed ? 'sticky' : ''}`}
      data-cy="masthead"
    >
      {headerMessage && <p className="header-message">{headerMessage}</p>}
      <div className="masthead-core">
        <SchoolDetails
          collapsed={collapsed}
          schoolName={schoolName}
          handleCollegeUrlClick={handleCollegeUrlClick}
          {...rest}
        />
        <WebLinks
          hubsWebLinks={hubsWebLinks}
          collegeName={schoolName}
          userData={userData}
          collegeContact={collegeContact}
          admissionsOffice={admissionsOffice}
          sendEmail={sendEmail}
          virtualTour={virtualTour}
        />
      </div>
    </div>
  );
}

Masthead.prototypes = {
  scid: PropTypes.number,
  hubsWebLinks: PropTypes.shape({
    premium_links: PropTypes.array,
  }),
  schoolName: PropTypes.string,
  collapsed: PropTypes.bool,
  address: PropTypes.string,
  url: PropTypes.string,
  urlText: PropTypes.string,
  isFavorite: PropTypes.bool,
  toggleFavorite: PropTypes.func,
  isApplyingTo: PropTypes.bool,
  ceebCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  userData: PropTypes.object,
  collegeContact: PropTypes.array,
  admissionsOffice: PropTypes.object,
  sendEmail: PropTypes.func,
  virtualTour: PropTypes.string,
  headerMessage: PropTypes.string,
};
